// The product list, for the form's commodity multi-select and the register's commodity filter.

import { useEffect, useState } from 'react';

import { getReferenceLists } from '../api.js';

export default function useProducts() {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  useEffect(() => {
    getReferenceLists()
      .then((lists) => setProducts(lists.product ?? []))
      .catch((err) => setError(err.message));
  }, []);
  return { products, error };
}
